import React from 'react'

// Components
import Table from 'components/Table'
import Skeleton from 'components/Skeleton'

// Styles
import {
  Wrapper,
  SkeletonAvatar,
  StyledLoadingTableCell,
  StyledTableRow,
} from './MembersTableLoading.styles'

// Types
interface MembersTableLoadingProps {
  items: number
}

/*
 * Renders Skeleton UI for the members table
 */
const MembersTableLoading: React.FC<MembersTableLoadingProps> = ({ items }) => (
  <Wrapper data-testid="members-table-loading" hasFadedBottom>
    <Table
      header={[]}
      items={Array.from({ length: items }, (_, index) => index)}
      renderItem={item => (
        <StyledTableRow key={item} data-testid="members-table-skeleton-row">
          <StyledLoadingTableCell>
            <SkeletonAvatar />
            <Skeleton height="20px" width="100%" />
          </StyledLoadingTableCell>
          <StyledLoadingTableCell data-testid="member-access">
            <Skeleton height="20px" width="50%" />
          </StyledLoadingTableCell>
          <StyledLoadingTableCell>
            <Skeleton height="20px" width="30%" />
          </StyledLoadingTableCell>
        </StyledTableRow>
      )}
      hideHeader
      evenColumns
    />
  </Wrapper>
)

export default MembersTableLoading
